import {Injectable} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

@Injectable({
    providedIn: "root",
})
export class DialogService {
    constructor(public dialog: MatDialog) {
    }

    openDialog(component: any, data?: any): MatDialogRef<any> {
        this.dialog.closeAll();
        return this.dialog.open(component, {
            data: data
        });
    }
}